
import React, { useState, useRef, useEffect } from 'react';
import { Document, Page } from "react-pdf";
import { PDFNavigation } from "../PDFNavigation";

interface PDFContentViewerProps {
  fileUrl: string;
  isTrainee: boolean;
  isAdmin: boolean;
  onComplete?: () => void;
}

export function PDFContentViewer({
  fileUrl,
  isTrainee,
  isAdmin,
  onComplete
}: PDFContentViewerProps) {
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState<number>(800);
  const containerRef = useRef<HTMLDivElement>(null);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
    console.log(`PDF loaded successfully with ${numPages} pages`);
  }

  const handlePageChange = (newPage: number) => {
    setPageNumber(newPage);
  };
  
  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.clientWidth;
        setPageWidth(containerWidth);
      }
    };
    
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <div className="flex flex-col h-full w-full">
      <PDFNavigation
        pageNumber={pageNumber}
        numPages={numPages}
        isTrainee={isTrainee && !isAdmin}
        onPageChange={handlePageChange}
      />
      <div className="flex-1 overflow-auto w-full h-full" ref={containerRef}>
        <Document
          file={fileUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<div className="text-center py-4">Loading PDF...</div>}
          error={<div className="text-center py-4 text-red-500">Failed to load PDF. Please check the URL or refresh the page.</div>}
          options={{
            cMapUrl: 'https://unpkg.com/pdfjs-dist@3.4.120/cmaps/',
            cMapPacked: true,
          }}
        >
          {numPages > 0 && (
            <Page
              pageNumber={pageNumber || 1}
              loading={<div className="text-center py-4">Loading page...</div>}
              width={pageWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              className="mx-auto"
            />
          )}
        </Document>
      </div>
    </div>
  );
}
